import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, Shield, HandHeart, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { FourStars, StarsDivider } from "../components/FourStars";

export default function EastSupportPage() {
  return (
    <div data-testid="east-support-page">
      <section className="relative py-28 md:py-40 text-white overflow-hidden">
        <div className="absolute inset-0" style={{ backgroundImage: `url(https://images.pexels.com/photos/30219277/pexels-photo-30219277.jpeg)`, backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0F1A]/85 via-[#0A0F1A]/70 to-[#0A0F1A]" />
        <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#CE1126]" />
            <span className="text-xs uppercase tracking-[0.3em] text-[#CE1126]">Soutien à l'Est du Congo</span>
            <span className="w-10 h-px bg-[#CE1126]" />
          </div>
          <h1 className="font-display text-4xl md:text-6xl leading-tight">
            La nation entière, debout pour <br/><span className="text-[#D4AF37]">la paix et la dignité</span>.
          </h1>
          <p className="text-white/80 mt-6 max-w-2xl mx-auto text-lg leading-relaxed">
            Les Amis de Fatshi Béton se mobilisent pour soutenir les populations déplacées et appuyer
            les efforts du gouvernement pour ramener la paix.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: HandHeart, title: "Aide humanitaire", text: "Appui aux déplacés internes : vivres, abris, soins, accompagnement psychologique." },
              { icon: Shield, title: "Diplomatie active", text: "Nous saluons et soutenons les efforts diplomatiques du Président pour la paix." },
              { icon: Heart, title: "Solidarité nationale", text: "Une mobilisation citoyenne permanente — chaque congolais peut contribuer." },
            ].map((b, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="bg-white rounded-2xl p-8 border border-black/5 shadow-sm"
                data-testid={`east-pillar-${i}`}
              >
                <div className="w-12 h-12 rounded-md bg-[#CE1126]/10 text-[#CE1126] flex items-center justify-center">
                  <b.icon size={22} />
                </div>
                <h3 className="font-display text-2xl mt-5 text-[#0A0F1A]">{b.title}</h3>
                <p className="text-sm text-[#475569] mt-3 leading-relaxed">{b.text}</p>
              </motion.div>
            ))}
          </div>

          <StarsDivider />

          <div className="bg-gradient-to-br from-[#0052CC] to-[#0A0F1A] rounded-3xl p-10 md:p-14 text-white relative overflow-hidden">
            <div className="absolute inset-0 stars-pattern opacity-15" />
            <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div>
                <FourStars size={14} className="mb-4" />
                <h2 className="font-display text-3xl md:text-4xl leading-tight">Apportez votre pierre à l'édifice de la paix.</h2>
                <p className="text-white/80 mt-4">Chaque don ciblé "Soutien à l'Est" est intégralement affecté aux actions humanitaires.</p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 md:justify-end">
                <Button asChild size="lg" className="bg-[#D4AF37] hover:bg-[#B5952F] text-[#0A0F1A] rounded-sm" data-testid="east-donate-btn">
                  <Link to="/dons"><Heart className="mr-2" size={18} /> Faire un don</Link>
                </Button>
                <Button asChild size="lg" variant="outline" className="border-white/40 text-white hover:bg-white hover:text-[#0052CC] rounded-sm">
                  <Link to="/register">Rejoindre A.F.B. <ArrowRight size={16} className="ml-2" /></Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
